const initEditarPerfil = () => {
    const editarBtn = document.querySelector("#editar-perfil");

    if (!editarBtn) return;

    editarBtn.addEventListener("click", function () {
        const rowFormularios = document.querySelectorAll(".edit-values");

        rowFormularios.forEach(row => {
            row.classList.toggle("active");
        });

        const labels = document.querySelectorAll(".row-formulario .label");
        
        labels.forEach(label => {
            label.classList.toggle("active");
        });

        const values = document.querySelectorAll(".row-formulario .value");
        
        values.forEach(value => {
            value.classList.toggle("hidden");
        });

        // Cambiar el texto del botón
        if (editarBtn.textContent.includes("Editar")) {
            editarBtn.innerHTML = `<svg class="icon icon-editar" aria-hidden="true"><use xlink:href="#icon-editar"></use></svg> Cerrar`;
        } else {
            editarBtn.innerHTML = `<svg class="icon icon-editar" aria-hidden="true"><use xlink:href="#icon-editar"></use></svg> Editar`;
        }
    });

    const btnGuardar = document.querySelector("#guardar-perfil");
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const restBase = protocol + '//' + hostname + '/wp-json/user-rest/v1';

    if (btnGuardar) {
        btnGuardar.addEventListener("click", function () {
            let user_id = btnGuardar.getAttribute("data-userID");
            let first_name = document.querySelector("input[name='first_name']").value;
            let last_name = document.querySelector("input[name='last_name']").value;
            let user_email = document.querySelector("input[name='user_email']").value;
            let new_user_email = document.querySelector("input[name='new_user_email']").value;
            let pais = document.querySelector("select[name='pais']").value;
            let ocupacion = document.querySelector("input[name='ocupacion']").value;
            let cumpleanos = document.querySelector("input[name='cumpleanos']").value;
            let discapacidad = document.querySelector("input[name='discapacidad']").value;
            let telefono = document.querySelector("input[name='telefono']").value;

            if (!first_name || !last_name || !user_email || !pais || !ocupacion || !cumpleanos || !discapacidad || !telefono) {
                alert('Por favor, complete todos los campos');
                return;
            }

            const data = {
                action: 'user_rest',
                user_id,
                first_name,
                last_name,
                user_email,
                new_user_email,
                pais,
                ocupacion,
                cumpleanos,
                discapacidad,
                telefono
            };

            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': user_rest.apiNonce,
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    data: data,
                }),
            };

            fetch(restBase + '/update', options)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // Mostrar mensaje de éxito
                        alert('Perfil actualizado correctamente');
                        // Recargar la página para mostrar los cambios
                        window.location.reload();
                    } else {
                        // Mostrar mensaje de error
                        alert('Error al actualizar el perfil: ' + data.data.message);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    alert('Ocurrió un error al actualizar el perfil');
                }); 
        });
    }
}

export default initEditarPerfil;